/** Passed in list/proxy_list args; stripped before the Truto API call. */
export const TRUTO_EXPLORER_SINGLE_PAGE_ARG = 'single_page' as const
